import classNames from 'classnames';
import React from 'react';
import styles from './addEvents.module.scss'
import { Row, Col, Form, Input, Button, DatePicker, Radio, Space, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import UploadImg from './UploadImg';
import ContentForm from './ContentForm';
import { fileUpload } from "@/apis/public";
import { addEvents, getParams, editEvents } from "@/apis/events";
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';

const AddEvents = () => {
	const [form] = Form.useForm();
	let [searchParams] = useSearchParams();
	const eventsId = searchParams.get('id');
	const [type, setType] = useState(1);
	const [coverFileEn, setCoverFileEn] = useState([]);// 封面图片（英文）
	const [coverFileZh, setCoverFileZh] = useState([]);// 封面图片（中文）
	const [imageFileEn, setImageFileEn] = useState([]);// 主图（英文）
	const [imageFileZh, setImageFileZh] = useState([]);// 主图（中文）
	const [img_id, setImg_id] = useState({});// 图片id
	const [loading, setLoading] = useState(false)
	const navigate = useNavigate();

	const getDetail = () => {
		getParams({
			eventsUuid: eventsId
		}).then(res => {
			const result = res?.data || {}
			form.setFieldsValue({
				title: result?.title,
				titleEn: result?.titleEn,
				imageName: result?.imageName,
				imageNameEn: result?.imageNameEn,
				text: result?.text,
				textEn: result?.textEn,
				eventsContentParams: result?.eventsContentParams || [],
				eventsContentParamsEn: result?.eventsContentParamsEn || [],
				eventsType: result?.eventsType || "Community Announcement",
				phenomenonTime: moment(result?.phenomenonTime),
				link: result?.link || "",
				author: result?.author || "",
				coverFileEn: "file",
			})
			setImg_id({
				coverFileUuidEn: result?.coverFileUuidEn,
				coverFileUuid: result?.coverFileUuid,
				imageFileUuidEn: result?.imageFileUuidEn,
				imageFileUuid: result?.imageFileUuid,
			})

			if (result?.link) {
				setType(1)
			} else {
				setType(2)
			}
		})
	}

	useEffect(() => {
		if (eventsId) {
			getDetail()
		} else {
			form.setFieldValue('eventsType', "Community Announcement")
		}
	}, [eventsId])

	useEffect(() => {
		if (!img_id.coverFileUuidEn) {
			form.setFieldValue('coverFileEn', "")
		}
	}, [img_id.coverFileUuidEn])

	const uploadFile = (list) => {
		return new Promise((resolve, reject) => {
			if (list.length > 0) {
				const formData = new FormData()
				formData.append("multipartFiles", list[0].xhr)
				formData.append("secondType", "Events")
				fileUpload(formData).then(res => {
					const fileUuids = res?.data[0]?.fileUuid || ''
					resolve(fileUuids)
				}).catch(err => {
					return false
				})
			} else {
				resolve("")
			}
		})
	}

	const onFinish = (values) => {
		setLoading(true)
		// 先上传文件
		Promise.all(
			[uploadFile(coverFileEn),
			uploadFile(coverFileZh),
			uploadFile(imageFileEn),
			uploadFile(imageFileZh)]
		).then((res) => {
			const params = { ...values };
			delete params.coverFileEn;
			params.phenomenonTime = values.phenomenonTime.format('YYYY-MM-DD HH:mm:ss')
			if (eventsId) {
				// 编辑  有新的图片资源用新的 没有则用旧的图片资源id
				params.eventsUuid = eventsId
				params.coverFileUuidEn = res[0] || img_id.coverFileUuidEn
				params.coverFileUuid = res[1] || img_id.coverFileUuid
				params.imageFileUuidEn = res[2] || img_id.imageFileUuidEn
				params.imageFileUuid = res[3] || img_id.imageFileUuid
				edit(params)
			} else {
				// 新增
				params.coverFileUuidEn = res[0]
				params.coverFileUuid = res[1]
				params.imageFileUuidEn = res[2]
				params.imageFileUuid = res[3]
				add(params)
			}
		})
	}

	const add = (params) => {
		addEvents(params).then(res => {
			setLoading(false)
			message.success('新增成功')
			navigate('/administration/events')
		}).catch(err => {
			setLoading(false)
		})
	}

	const edit = (params) => {
		editEvents(params).then(res => {
			setLoading(false)
			message.success('修改成功')
			navigate('/administration/events')

		}).catch(err => {
			setLoading(false)
		})
	}
	useEffect(() => {
		if (coverFileEn.length > 0) {
			form.setFieldValue('coverFileEn', "file")
			form.validateFields(['coverFileEn'])
		} else {
			form.setFieldValue('coverFileEn', "")
		}
	}, [coverFileEn])

	const msg = "请填写必填项"
	return <Spin spinning={loading}>
		<div className={classNames('container', styles.addEventsBox)}>
			<h3>新增事件</h3>
			<Form name="basic"
				onFinish={onFinish}
				autoComplete="off"
				labelCol={{ flex: "90px" }}
				form={form}
				initialValues={{
					eventsContentParamsEn: [{
						title: '',
						paragraphParams: [
							{
								text: '',
								imageName: '',
							},
						],
					}],
					eventsContentParams: [{
						title: '',
						paragraphParams: [
							{
								text: '',
								imageName: '',
							},
						],
					}],
				}}
				variant="filled">
				<Row gutter={80}>
					<Col span={12}>
						<Form.Item
							label="报导时间"
							name="phenomenonTime"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<DatePicker
								format="YYYY-MM-DD HH:mm:ss"
								style={{ width: "100%" }}
								showTime
							/>
						</Form.Item>
					</Col>

					<Col span={12}>
						<Form.Item
							label="作者"
							name="author"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input />
						</Form.Item>
					</Col>

					<Col span={12}>
						<Form.Item
							label="类型"
							name="eventsType"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Radio.Group
								options={[
									{ value: "Community Announcement", label: "社区公告" },
									// { value: "Community Activity Events", label: "社区活动推送" },
								]}
							/>
						</Form.Item>
					</Col>

					<Col span={12}>
						<Form.Item
							label="来源"
						>
							<Radio.Group
								value={type}
								onChange={(e) => {
									setType(e.target.value)
								}}
								options={[
									{ value: 1, label: "外部链接" },
									{ value: 2, label: "站内事件" },
								]}
							/>
						</Form.Item>
					</Col>

					<Col span={12}>
						<div className={styles.langTitle}>【英文版】</div>
						<Form.Item
							label="标题"
							name="titleEn"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input />
						</Form.Item>
					</Col>
					<Col span={12}>
						<div className={styles.langTitle}>【中文版】</div>
						<Form.Item
							label=""
							name="title"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="描述"
							name="textEn"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input.TextArea rows={4} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label=""
							name="text"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input.TextArea rows={4} />
						</Form.Item>
					</Col>

					<Col span={12}>
						<Form.Item
							label="封面图片"
							name="coverFileEn"
							rules={[
								{
									required: true,
									message: msg,
								},
							]}
						>
							<UploadImg fileList={coverFileEn} setFileList={setCoverFileEn} fileId={img_id} propKey="coverFileUuidEn" changeImg={setImg_id} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label=""
						>
							<Space>
								<UploadImg fileList={coverFileZh} setFileList={setCoverFileZh} fileId={img_id} propKey="coverFileUuid" changeImg={setImg_id} />
								<span className={styles.imgBox}>（*非必传，不传与英文版使用同一张封面图）</span>
							</Space>

						</Form.Item>
					</Col>
					{type === 1 && <Col span={24}>
						<Form.Item
							label="外部链接"
							name="link"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input />
						</Form.Item>
					</Col>}
					{type === 2 &&
						<React.Fragment>
							<Col span={12}>
								<Form.Item
									label="主图"
								>
									<UploadImg fileList={imageFileEn} setFileList={setImageFileEn} fileId={img_id} propKey="imageFileUuidEn" changeImg={setImg_id} />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									label=""
								>
									<Space>
										<UploadImg fileList={imageFileZh} setFileList={setImageFileZh} fileId={img_id} propKey="imageFileUuid" changeImg={setImg_id} />
										<span className={styles.imgBox}>（*非必传，不传与英文版使用同一张主图）</span>
									</Space>

								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									label="主图名称"
									name="imageNameEn"
								>
									<Input />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									label=""
									name="imageName"
								>
									<Input />
								</Form.Item>
							</Col>
							<Col span={12}>
								<ContentForm msg={msg} propKey="eventsContentParamsEn" />
							</Col>
							<Col span={12}>
								<ContentForm msg={msg} propKey="eventsContentParams" />
							</Col>
						</React.Fragment>
					}
				</Row>
				<Form.Item>
					<Button type="primary" htmlType="submit">提交</Button>
				</Form.Item>
			</Form>
		</div>;
	</Spin>
}
export default AddEvents;